import { createTheme } from '@mui/material';

const theme = createTheme({
  palette: {
    primary: {
      main: '#4a0e1a',
      contrastText: '#f7f7f7',
      dark: '#411018ff',
      light: '#752D3C',
    },
    secondary: {
      main: '#FBE99C',
      contrastText: '#f7f7f7',
      dark: '#FFE46E',
      light: '#FFF5D7',
    },
    background: {
      default: '#f7f7f7',
      paper: '#fff',
    },
  },
  typography: {
    allVariants: {
      color: '#000',
    },
    fontSize: 14,
    fontFamily: [
      '"Montserrat"',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },
  shape: {
    borderRadius: 4,
  },
  components: {
    MuiTab: {
      defaultProps: {
        style: {
          textTransform: 'none',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        contained: ({ ownerState, theme }) => ({
          boxShadow: 'none',
          textTransform: 'none',
          borderRadius: 6,
          ...(ownerState.color === 'primary' && {
            background: 'linear-gradient(45deg, #752D3C 30%, #4a0e1a 70%)',
            color: theme.palette.primary.contrastText,
          }),
          ...(ownerState.color === 'secondary' && {
            background: 'linear-gradient(45deg, #ddc86bff 30%, #ceb12fff 70%)',
            color: theme.palette.secondary.contrastText,
          }),
        }),
        text: {
          boxShadow: 'none',
          textTransform: 'none',
          borderRadius: 6,
        },
        outlined: {
          boxShadow: 'none',
          textTransform: 'none',
          borderRadius: 6,
        },
      },
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          marginRight: '0px!important',
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        h6: {
          fontWeight: 500,
        },
        h5: {
          fontWeight: 500,
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: 'outlined',
      },
      styleOverrides: {
        root: {
          height: 'auto',
        },
      },
    },
    MuiIcon: {
      styleOverrides: {
        root: {
          padding: 8,
          height: 40,
          width: 40,
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          padding: '10px!important',
        },
      },
      defaultProps: {
        style: {
          padding: '0px!important',
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          top: -6,
        },
        shrink: {
          top: 0,
        },
      },
    },
    MuiInputAdornment: {
      styleOverrides: {
        positionEnd: {
          marginRight: 10,
        },
        positionStart: {
          marginLeft: 10,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          padding: '0px!important',
        },
      },
    },
    MuiSelect: {
      defaultProps: {
        variant: 'outlined',
      },
      styleOverrides: {
        outlined: {
          padding: 10,
          height: 'unset',
        },
      },
    },
    MuiTabs: {
      defaultProps: {
        indicatorColor: 'secondary',
        textColor: 'inherit',
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          border: 'none',
        },
      },
    },
  },
});

export { theme };
